import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../../common/Toast";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../common/Constant";

const BatchSale = (props) => {
  let navigate = useNavigate();

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const LocationId = localStorage.getItem("Location");

  const [selectedImage, setSelectedImage] = useState("");
  const [loading, setLoading] = useState(false);

  const [ImageUrl, setImageUrl] = useState("");

  let fields, excelReadData;

  const downloadExcel = () => {
    const SaleExcelColumnName = [
      { Field: "ItemId" },
      { Field: "SellingPrice" },
      { Field: "Qty" },
      { Field: "Discount" },
      { Field: "Description" },
      { Field: "Serial" },
    ];

    let dataFields = SaleExcelColumnName.map((obj) => obj.Field);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    // XLSX.utils.sheet_add_aoa(ws, data);
    XLSX.utils.sheet_add_aoa(ws, [dataFields]);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const binaryData = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([binaryData], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "import_batch_Sale.xlsx";
    link.click();
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    console.log(file, "file")
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_csv(sheet);

      const processedData = Papa.parse(rawData, {
        header: true,
        transformHeader: (header) => header.replace(/\s+|-|\/|#/g, ""),
      }).data;
      excelReadData = processedData;
      console.log(excelReadData, "excelReadData")


      const rows = rawData.split("\n");
      const data = rows.map((row) => row.split(","));
      fields = data[0];
    };

    reader.readAsBinaryString(file);
  };


  const handleSubmit = () => {
    // setLoading(true);
    const changeCountInventoryArray = excelReadData.map((obj, index) => ({
      Id: index + 1,
      ItemId: obj.ItemId,
      SellingPrice: obj.SellingPrice,
      Qty: obj.Qty,
      Discount: obj.Discount,
      Description: obj.Description,
      Serial: obj.Serial,
    }));

    let CountInventoryExcel = changeCountInventoryArray.filter(function (
      countinventoryexcel
    ) {
      return countinventoryexcel.ItemId !== "";
    });

    const countinventoryexcelobj = {};
    countinventoryexcelobj.importDataXML = CountInventoryExcel;
    let countinventoryexceljsonstring = JSON.stringify(countinventoryexcelobj);

    let BatchData = {
      xmlImportData: countinventoryexceljsonstring,
      saleid: 0,
      locationid: LocationId,
      loginUserId: Id,
    };
    axios.post(`${config.salesconfigBaseUrl}/sales/batchsalesimportdata`,
      BatchData,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      }
    )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate(`/manage-sales/${res.data.ResponseID}`);
        } else {
          // setSuccessMessageHideShow(false);
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("err ==> ", err);
        setLoading(false);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header"
            style={
              {
                position: "fixed",
                top: "2px",
                zIndex: "999"
              }
            }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sales">Sales</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link>Batch Sale</Link>
                </li>
              </ul>
            </div>
          </div>
          <form>
            {/* {divs} */}
            <div className="card">
              <div className="card-body">
                <div className="add">
                  <div className="col-sm-4">
                    <div className="form-group row">
                      <label className="col-form-label col-md-2">Step 1</label>
                      <label>Download file for batch sale</label>
                      <div className="col-md-10">
                        <button
                          type="button"
                          // onClick={handleSubmit}
                          className="btn btn-primary btn-sm w-100"
                          onClick={downloadExcel}
                        >
                          Download Excel Template for Batch Sale
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group row">
                      <label className="col-form-label col-md-2">Step 2</label>
                      <label>Import Batch Sale file</label>
                      <div className="col-md-10">
                        <input
                          type="file"
                          className="form-control"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          onChange={handleFile}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div
                        className={`${ImageUrl ? "" : selectedImage ? "" : "d-none"
                          } form-group row`}
                      >
                        <label className="col-form-label col-md-2 form-label"></label>
                        <div className="col-md-10">
                          <img
                            src={`${ImageUrl ? ImageUrl : selectedImage}`}
                            alt="Category Image"
                            className="ImagePreviewSize"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="save pull-left">
                  <Link to="/sales" className="btn btn-secondary btn-sm me-1 mt-2">
                    Cancel
                  </Link>
                  <button type="button" onClick={handleSubmit} className="btn btn-primary btn-sm mx-2 mt-2">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BatchSale;
